export default __webpack_public_path__ + "static/media/Feat1.c91e0c33.jpeg";